import {BaseObject} from './BaseObject';
import {DocumentCompany} from './DocumentCompany';
import {DocumentType} from './DocumentType';
import {DocumentCompanyAccount} from './DocumentCompanyAccount';
import {Customer} from './Customer';
import {PaymentTypeEntity} from './PaymentType';
import {DocumentItem} from './DocumentItem';
import {Contract} from './Contract';
import {DocumentLiquidation} from './DocumentLiquidation';
import {DocumentCurrency} from './DocumentCurrency';

export class Document extends BaseObject {

    id: number;
    fullNumber: string;
    variableSymbol: string;
    documentCompany: DocumentCompany = null;
    documentType: DocumentType;
    documentCompanyAccount: DocumentCompanyAccount;
    documentLiquidation: DocumentLiquidation = null;
    paymentType: PaymentTypeEntity;
    customer: Customer = null;
    clientName: string;
    clientStreet: string;
    clientCity: string;
    clientZip: string;
    description: string = null;
    clientCompanyNumber: string = null;
    clientVatNumber: string = null;
    isLocked: boolean = false;
    issueDate: Date;
    taxDate: Date;
    dueDate: Date;
    sentDate: Date;
    documentCurrency: DocumentCurrency = null;

    paymentDate: Date; // finální datum celé úhrady
    items: DocumentItem[] = [];
    totalPaid: number;
    links: any = [];
    contract: Contract = null;
    isPaid: boolean = false;
    isExported: boolean = false;
    orderNumber: string = null;
    orderDate: Date = null;

    proformaInformation: any;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/Document.ts